import { toast } from 'react-toastify';
import { apiClient } from './client';
import { extractPagedItemsAndTotal, handleApiError } from './utils';

export const patchAccidentFileInsuranceApplication = async ({
    accidentFileId,
    insuranceApplicationType,
    insuranceApplicationDate,
    readyForArbitration = true
}) => {
    if (!accidentFileId) {
        toast.error('Kaza dosyası ID\'si gereklidir.');
        throw new Error('Accident file ID is missing for insurance application patch.');
    }

    if (!insuranceApplicationType) {
        toast.error('Sigorta başvuru türü gereklidir.');
        throw new Error('Insurance application type is missing for insurance application patch.');
    }

    if (!insuranceApplicationDate) {
        toast.error('Sigorta başvuru tarihi gereklidir.');
        throw new Error('Insurance application date is missing for insurance application patch.');
    }

    try {
        const endpoint = `/AccidentFile/patch-accidentfile-insuranceapplication/${accidentFileId}`;

        const requestBody = {
            readyForArbitration: Boolean(readyForArbitration),
            insuranceApplicationType: insuranceApplicationType,
            insuranceApplicationDate: insuranceApplicationDate
        };

        const response = await apiClient.put(endpoint, requestBody);
        return response.data;

    } catch (error) {
        handleApiError(error, 'Sigorta başvuru bilgileri güncellenirken hata oluştu.', {
            toastPrefix: 'Sigorta başvuru bilgileri güncellenirken hata: '
        });

        throw error;
    }
};

export const fetchAccidentFilesReadyForArbitration = async ({
    apiEndpoint,
    page,
    pageSize,
    search,
    setDataCallback,
    setTotalRowsCallback,
}) => {
    try {
        const response = await apiClient.get(apiEndpoint, {
            params: {
                page,
                pageSize,
                search,
                readyForArbitration: true
            },
        });

        let items = [];
        const { rawItems, total } = extractPagedItemsAndTotal(response.data);

        if (Array.isArray(rawItems)) {
            items = rawItems.map(item => ({
                ...item,
                id: item.id || item.accidentFileId,
            }));
        }

        if (setDataCallback) setDataCallback(items);
        if (setTotalRowsCallback) setTotalRowsCallback(total);

    } catch (error) {
        handleApiError(error, 'Kaza dosyaları alınırken bir hata oluştu.');
        if (setDataCallback) setDataCallback([]);
        if (setTotalRowsCallback) setTotalRowsCallback(0);
    }
};

export const fetchClosedAccidentFiles = async ({
    apiEndpoint,
    page,
    pageSize,
    search,
    setDataCallback,
    setTotalRowsCallback,
}) => {
    try {
        const response = await apiClient.get(apiEndpoint, {
            params: {
                page,
                pageSize,
                search,
                fileIsClosed: true
            },
        });

        let items = [];
        const { rawItems, total } = extractPagedItemsAndTotal(response.data);

        if (Array.isArray(rawItems)) {
            items = rawItems.map(item => ({
                ...item,
                id: item.id || item.accidentFileId,
            }));
        }

        if (setDataCallback) setDataCallback(items);
        if (setTotalRowsCallback) setTotalRowsCallback(total);

    } catch (error) {
        handleApiError(error, 'Kapatılan kaza dosyaları alınırken bir hata oluştu.');
        if (setDataCallback) setDataCallback([]);
        if (setTotalRowsCallback) setTotalRowsCallback(0);
    }
};

export const closeAccidentFile = async ({ accidentFileId, fileStatus, fileCloseDescription, fileCloseComment }) => {
    if (!accidentFileId) {
        toast.error('Dosya kapatmak için kaza dosyası ID\'si gereklidir.');
        throw new Error('Accident file ID is missing for close file operation.');
    }

    if (!fileCloseDescription || !fileCloseDescription.trim()) {
        toast.error('Dosya kapatma açıklaması gereklidir.');
        throw new Error('File close description is missing for close file operation.');
    }

    try {
        const endpoint = `/AccidentFile/patch-accidentfile-close/${accidentFileId}`;

        const requestBody = {
            fileStatus: fileStatus,
            fileCloseDescription: fileCloseDescription.trim(),
            fileCloseComment: fileCloseComment ? fileCloseComment.trim() : fileCloseDescription.trim()
        };

        const response = await apiClient.put(endpoint, requestBody);
        return response.data;

    } catch (error) {
        handleApiError(error, 'Dosya kapatılırken bir hata oluştu.');

        throw error;
    }
};
